import React, { useCallback } from 'react';
import * as filestack from 'filestack-js';
import { getEnvConfig } from '@/constants';
import { getFilestackSecurity } from '@/utils/filestackSecurity';

// This file can be improved
export default function FilestackUploader({
  s3Path = getEnvConfig('FILESTACK_BUCKET_PATH'),
  allowManualRetry = true,
  acceptedTypes = ['video/*'],
  errorsTimeout = undefined,
  onUpload,
  children,
  ...rest
}) {
  const openPicker = useCallback(() => {
    const assetKind = acceptedTypes.some((type: string) => type.startsWith('video')) ? 'video' : 'image';
    const client = filestack.init(getEnvConfig('FILESTACK_API_KEY'));

    const options = {
      fromSources: ['local_file_system'],
      storeTo: {
        location: 's3',
        container: getEnvConfig('S3_STATIC_ASSETS_BUCKET'),
        path: s3Path,
        region: getEnvConfig('AWS_STORE_REGION')
      },
      accept: acceptedTypes,
      uploadConfig: {
        retry: 3,
        timeout: 60000
      },
      uploadInBackground: false,
      disableTransformer: true,
      maxFiles: 1,
      minFiles: 1,
      exposeOriginalFile: true,
      disableStorageKey: false,
      maxSize: 50 * 1024 * 1024, // change default size to 50MB, it used for images
      allowManualRetry,
      errorsTimeout,
      onUploadDone: (res: any) => {
        const resourceKey = encodeURIComponent(res.filesUploaded[0]?.key ?? '');
        onUpload(`${getEnvConfig('STATIC_ASSETS_CDN')}/${resourceKey}`);
      },
      // Sign here, not at picker open: the expiry is scaled to the file size and starts ticking now.
      onFileSelected: async (file: any) => {
        try {
          const { security } = await getFilestackSecurity(
            { intent: 'content_lab_root_asset', assetKind },
            { sizeBytes: file?.size }
          );
          client.setSecurity(security);
        } catch (e) {
          console.error('Filestack signing failed', e);
          return Promise.reject(e);
        }
      }
    };

    const picker = client.picker(options);
    picker.open();
  }, [s3Path, allowManualRetry, acceptedTypes, errorsTimeout, onUpload]);

  return (
    <div onClick={openPicker} {...rest}>
      {children}
    </div>
  );
}
